module.exports = __webpack_public_path__ + "img/benefit-09-chain-2.bcdfce2d.png";